import React, { useState } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "../../Lib/utils";
import clsx from "clsx";

export const Tabs = TabsPrimitive.Root;

export const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "flex items-center gap-2 border-b border-gray-200 overflow-x-auto",
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

export const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "whitespace-nowrap py-2 px-3 border-b-4 border-transparent font-medium text-sm text-[#667499] transition-colors",
      "hover:text-primaryBlack",
      "data-[state=active]:border-primaryGreen data-[state=active]:text-primaryBlack data-[state=active]:font-bold",
      "focus:outline-none",
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

export const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn("pt-4 focus:outline-none", className)}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export default function NavTabs({ className, tabs, activeTab, setActiveTab }) {
  return (
    <div className={clsx("border-b border-gray-200", className)}>
      <nav
        className='-mb-px justify-center w-full md:w-0 md:justify-normal flex space-x-2 md:space-x-8 overflow-x-auto'
        aria-label='Tabs'
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={cn(
              "whitespace-nowrap py-2 px-1 border-b-4 rounded font-medium text-md",
              activeTab === tab.id
                ? "border-primaryGreen text-primaryBlack font-bold"
                : "border-transparent text-[#667499]  hover:text-[text-[#667499]/90 hover:border-[#667499]/90"
            )}
            aria-current={activeTab === tab.id ? "page" : undefined}
          >
            {tab.name}
          </button>
        ))}
      </nav>
    </div>
  );
}
